<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Book-Title">Private Gardens <br/><span class="BookTitleof _idGenCharOverride-1">of</span> Santa Barbara</p>
</div>
<div>
<p class="Book-Subtitle">THE ART OF OUTDOOR LIVING</p>
</div>
<div>
<p class="author">Margie Grace</p>
</div>
<div>
<p class="photographer">Photographs by Holly Lepere</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer000">
<img alt="Photo of logo." class="_idGenObjectAttribute-1" src="image/logo.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer001">
<img alt="Photo of garden." class="_idGenObjectAttribute-2" src="image/2_Grasses_lavendar.jpg"/>
</div>
</div>
<div class="pagebreak"></div>
<div>
<p class="Dedication">The gardens in this book share a common thread. No matter the project style, size, or budget, these gardens were created in collaboration with clients who were committed to extraordinary results.</p>
<p class="Dedication">With deepest gratitude to our clients—for their trust, their generosity of spirit, and their commitment to excellence. </p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer002">
<img alt="Photo of outdoor firepit." class="_idGenObjectAttribute-3" src="image/01_Padaro_Lane_2016.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer003">
<img alt="Photo of garden." class="_idGenObjectAttribute-4" src="image/10_hollister_ranch.jpg"/>
</div>
</div>
<div class="pagebreak"></div>
<div epub:type="toc" id="_idContainer004">
<h2 class="Title-blk">Contents</h2>
<p class="TOC-txt1"><a href="#/Private_Gardens_Santa_Barbara_Interiors#_idTextAnchor000">Introduction</a></p>
<p class="TOC-txt"><a href="#/Private_Gardens_Santa_Barbara_Interiors1#_idTextAnchor001">Sea Cliff</a></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors2#_idTextAnchor002" title="Link target outside of Sample">Sycamore Canyon </span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors3#_idTextAnchor003" title="Link target outside of Sample">The Lane</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors4#_idTextAnchor004" title="Link target outside of Sample">Whimsical Retreat</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors5#_idTextAnchor005" title="Link target outside of Sample">Pedregosa</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors6#_idTextAnchor007" title="Link target outside of Sample">Zen Garden</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors7#_idTextAnchor008" title="Link target outside of Sample">Garden of Eden</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors8#_idTextAnchor009" title="Link target outside of Sample">Villa Del Greco</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors9#_idTextAnchor010" title="Link target outside of Sample">Ocean Bluff</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors10#_idTextAnchor011" title="Link target outside of Sample">Terra Bella</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors11#_idTextAnchor012" title="Link target outside of Sample">Victoria Garden Mews</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors12#_idTextAnchor013" title="Link target outside of Sample">Paseo Tranquillo</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors13#_idTextAnchor014" title="Link target outside of Sample">Hollister Ranch</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors14#_idTextAnchor015" title="Link target outside of Sample">Wildlife Refuge</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors15#_idTextAnchor016" title="Link target outside of Sample">Shadow Hills</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors16#_idTextAnchor017" title="Link target outside of Sample">Monarch</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors17#_idTextAnchor018" title="Link target outside of Sample">Hidden Valley</span></p>
<p class="TOC-txt"><span href="#/Private_Gardens_Santa_Barbara_Interiors18#_idTextAnchor019" title="Link target outside of Sample">Painted Cave</span></p>
<p class="TOC-txt1"><span href="#/Private_Gardens_Santa_Barbara_Interiors18#_idTextAnchor021" title="Link target outside of Sample">Awards &amp; Accolades</span></p>
<p class="TOC-txt1"><span href="#/Private_Gardens_Santa_Barbara_Interiors18#_idTextAnchor022" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer005">
<img alt="Photo of garden." class="_idGenObjectAttribute-5" src="image/11_Sycamore_Canyon_2017.jpg"/>
</div>
</div>
<div>
<h2 class="Title-blk" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Introduction</h2>
</div>
<div>
<p class="txt"><span class="LEDE _idGenCharOverride-2">I am a garden maker.</span></p>
<p class="Normal">The job is an important one. Vital, in fact. Gardens connect us to nature. They offer beauty and inspiration. They sustain the birds and the bees. They sustain us. Done well, gardens send the soul soaring. </p>
<p class="Normal">We are creatures of nature. As such, we need to connect with nature. Deeply. Daily. To recharge our batteries, to feed our spirit, to inspire our dreams, to breathe in the oxygen exhaled by plants.</p>
<p class="Normal">Few of us, however, live the life of Thoreau on Walden Pond. We live near our jobs and our schools and sometimes our families. Usually in areas that are far removed from wildland. We get the critical nature fix we need from the gardens we build. Our gardens bring nature to our doorstep and connect us with the larger environment. Great gardens pull us irresistibly into the outdoors—to feel the warmth of the sun on our skin, to hear the birds sing, to lie in the shade with a book, to stop and smell the roses. </p>
<p class="Normal">Most of us live in cities, suburbs, or villages consisting of both built and natural environments that call forth certain behaviors and emotions. A busy urban center with chaotic traffic, for instance, leaves us feeling stressed out. A serene garden fosters a tranquil feeling. A well-organized office supports productivity. A whimsical space encourages playfulness. A place of beauty makes our heart sing. </p>
<p class="Normal">To make a truly great garden, one that rocks our world, requires listening keenly to the land and to the people who use the space. The landscapes pictured in these pages range from intimate gardens to large estates and run the gamut from sublime and naturalistic to bold and urban. Styles range from traditional to contemporary, romantic to whimsical, restrained to unapologetically exuberant. What they have in common, however, is what makes them truly great: each is a response to the unique character of the site, the architecture, and the larger environment, adapted to fit the lifestyle, personality, and practical needs of the people who live there. </p>
<p class="Normal">As you peruse the images in this book, I invite you to take ideas and inspiration for your own garden making.</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer006">
<img alt="Photo of garden." class="_idGenObjectAttribute-6" src="image/margie_signature_blk.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer007">
<img alt="Photo of author." class="_idGenObjectAttribute-7" src="image/margie_bio.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Private_Gardens_Santa_Barbara_Interiors.vue?379526c2